import Vue from "vue";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

Vue.component("SplideSlide", SplideSlide);
Vue.component("Splide", Splide);